import cx from 'classnames';
import './PaymentCards.scss';
import { DropdownMenu } from './DropdownMenu';
import { icons } from '../../assets';
const {
  VisaCardIcon,
  MasterCardIcon,
  AmexCardIcon,
  DiscoverCardIcon,
  DinersClubCardIcon,
  JCBCardIcon,
  UnionPayCardIcon,
  BankAccountIcon,
  CreditCardIcon,
} = icons;

const BRAND_ICON_MAPPING = {
  visa: VisaCardIcon,
  mastercard: MasterCardIcon,
  amex: AmexCardIcon,
  discover: DiscoverCardIcon,
  diners: DinersClubCardIcon,
  jcb: JCBCardIcon,
  unionpay: UnionPayCardIcon,
  'Bank account': BankAccountIcon,
};

function PaymentCards({
  brand,
  endingDigit,
  exp_month,
  exp_year,
  isPrimary,
  actionMenu,
  item,
  designV2 = false,
}) {
  const isBank = brand === 'Bank account';
  const Icon = BRAND_ICON_MAPPING[brand] || CreditCardIcon;

  return (
    <div
      className={cx(
        'desktop-settings-billing-card-row',
        designV2 ? 'design-v2' : '',
        isPrimary ? 'selected' : ''
      )}>
      <div className={'desktop-settings-billing-payment-row'}>
        <div className={'desktop-settings-billing-div-2'}>
          <div className={'desktop-settings-billing-div-2'}>
            <div className={'desktop-settings-billing-card-content'}>
              <Icon
                className={'desktop-settings-billing-screenshot-at'}
                style={{
                  ...(isBank && { maxHeight: '25px' }),
                }}
              />
            </div>
            <div className={cx('desktop-settings-billing-title-2', designV2 ? 'pm-title' : '')}>
              <span className="pm-brand">
                {brand.charAt(0).toUpperCase() + brand.slice(1)} ending in {endingDigit}
              </span>
              {designV2 && exp_month && exp_year ? (
                <span className="pm-expiry">
                  Expires on {exp_month}/{exp_year?.slice(2)}
                </span>
              ) : null}
            </div>
            {isPrimary && (
              <label className={cx('inline-tag', designV2 ? 'pm-tag' : '')}>PRIMARY</label>
            )}
          </div>
        </div>
        {!isPrimary ? <DropdownMenu menu={actionMenu} item={item} /> : null}
      </div>
    </div>
  );
}

export default PaymentCards;
